import React, { MouseEventHandler, useCallback } from 'react'

import SelectTripModalView from '../TripModal/SelectTripModalView'

import {
  tripLoginModalSignUpDismiss,
  tripLoginModalSignUpView,
} from 'analytics/eventDefinitions'
import { fireInteractionEvent } from 'api/googleTagManager'
import TextButton from 'components/Luxkit/Button/TextButton'
import LineHeartIcon from 'components/Luxkit/Icons/line/LineHeartIcon'
import useLoginBeforeCallback from 'hooks/usePendingLoginHandler'
import { SAVE_ITEM_COPY } from 'tripPlanner/config'
import { useCuratedTrip } from 'tripPlanner/hooks/api'
import useOpenModal from 'tripPlanner/hooks/View/useOpenModal'
import { TripItem } from 'tripPlanner/types/tripItem'

export const SAVE_CURATED_TRIP_BUTTON_CLASS = 'curated-trip-save-button'

interface Props {
  item: TripItem
  tripId: string
  className?: string
  label?: string
}

const trackTripLoginModalSignUpView = () => {
  fireInteractionEvent(tripLoginModalSignUpView('save_curated_trip_item'))
}
const trackTripLoginModalSignUpDismiss = () => {
  fireInteractionEvent(tripLoginModalSignUpDismiss('save_curated_trip_item'))
}

function SaveCuratedTripItemButton({
  item,
  label = SAVE_ITEM_COPY,
  className,
  tripId,
}: Props) {
  const { data: curatedTrip } = useCuratedTrip({
    tripId,
  })
  const openModal = useOpenModal()

  const openTripSelect = useCallback(() => {
    if (curatedTrip) {
      openModal(SelectTripModalView, { trip: curatedTrip, item })
    }
  }, [curatedTrip, item, openModal])

  const onSave = useLoginBeforeCallback(
    openTripSelect,
    'tripPlannerLogin',
    trackTripLoginModalSignUpView,
    trackTripLoginModalSignUpDismiss,
  )

  const onClick: MouseEventHandler = useCallback(
    (e) => {
      e.preventDefault()
      e.stopPropagation()

      onSave()
    },
    [onSave],
  )

  if (!curatedTrip) {
    return null
  }

  return (
    <TextButton
      kind="secondary"
      startIcon={<LineHeartIcon />}
      onClick={onClick}
      className={className}
    >
      {label}
    </TextButton>
  )
}

export default SaveCuratedTripItemButton
